import { Injectable, inject } from '@angular/core';
import { AuthPayload } from './models/auth.payload';
import { environment } from '../../../../environments/environment';
import { TokenDto } from './models/token.dto';
import { LocalStorage } from '../local-storage/local-storage.service';
import { MeService } from '../me/me.service';
import { Router } from '@angular/router';
import { Api } from '../api/api';
import { PaginationCacheService } from '../pagination/pagination-cache.service';
import { ToastService } from '../../components/toast/service/toast.service';
import { jwtDecode } from 'jwt-decode';
import { RolesHelper } from '../../../helpers/roles.helper';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  constructor(
    private readonly router: Router,
    private readonly meService: MeService,
    private readonly localStorage: LocalStorage,
    private readonly toast: ToastService,
  ) { }

  private readonly api: Api = new Api();

  private readonly paginationCache = inject(PaginationCacheService);

  public rolesHelper = new RolesHelper();

  public async login(payload: AuthPayload): Promise<TokenDto | void> {
    const { error, success } = await this.api.postAsync<TokenDto>(environment.routes.auth.login, payload);

    if (error || !success)
      return this.toast.error(error?.message ?? 'Erro ao realizar o login');

    const tokenPayload: { roles: string, isActive: boolean } = jwtDecode(success.token);

    if(!(this.rolesHelper.hasAdminRoles(tokenPayload.roles) || this.rolesHelper.hasManagerRoles(tokenPayload.roles)))
      return this.toast.error('Você não tem permissão para acessar esses recursos.');

    this.saveToken(success);
    await this.meService.storageMe();

    return success;
  }

  public async refreshToken(): Promise<boolean> {
    const api = new Api();

    const { success: token } = await api.getAsync<TokenDto>(environment.apiUrl + environment.routes.auth.refresh, {
      cancelInterceptors: true,
    });

    if (token)
      this.saveToken(token);

    return !!token;
  }

  public async logout(): Promise<void> {
    this.localStorage.clear();
    this.paginationCache.clearAll();
    await this.router.navigateByUrl('/login');
  }

  public isLoggedIn(): boolean {
    const token = this.localStorage.getItem<TokenDto>(environment.keys.token);
    return !!token;
  }

  public getToken(): TokenDto | null {
    return this.localStorage.getItem<TokenDto>(environment.keys.token);
  }

  private saveToken(token: TokenDto): void {
    this.localStorage.setItem(environment.keys.token, token);
  }

}
